// Ändrat lite ordning 

export const passett =     
[
    {
        "name": "Långsamma ryck",
        "percent": [33,	33,	33,	33],
        "reps": [3, 3, 3, 3],
        "setsDone": [false, false, false, false, false],
        "description": "Långsamma ryck, slowmotion till mitten lår sen full fart",
        "done": false,
        "TypeOfPr": "snatch",
        "ovningNr": 0
    },
    {
        "name": "Ryck",
        "percent": [52,	57,	62,	67,	70,	73,	73],
        "reps": [3, 3, 3, 3, 3, 3, 3],
        "setsDone": [false, false, false, false, false, false],
        "description": "",
        "done": false,
        "TypeOfPr": "snatch",
        "ovningNr": 1
    },
    {
        "name": "Ryckböj",
        "percent": [47,	52,	55,	58,	58],
        "reps": [3, 3, 3, 3, 3],
        "setsDone": [false, false, false, false, false, false],
        "description": "Ryckböj med stötfattning",
        "done": false,
        "TypeOfPr": "snatch",
        "ovningNr": 2
    },
    {
        "name": "Överstöt",
        "percent": [22,	27,	32,	37,	40,	43,	43],
        "reps": [4, 4, 4, 4, 4, 4, 4],
        "setsDone": [false, false, false, false, false, false],
        "description": "Överstöt utan bendriv",
        "done": false,
        "TypeOfPr": "clean",
        "ovningNr": 3
    },
    {
        "name": "L-Situps",
        "percent": [10,	10,	10],
        "reps": [6, 6, 6],
        "setsDone": [false, false, false, false, false, false],
        "description": "L-Situps 3x6",
        "done": false,
        "TypeOfPr": "clean",
        "ovningNr": 4
    }
];

export const tisdag = 
[
    {
        "name": "Långsamma ryck",
        "percent": [33,	33,	33,	33],
        "reps": [3, 3, 3, 3],
        "setsDone": [false, false, false, false, false],
        "description": "Långsamma ryck, slowmotion till mitten lår sen full fart",
        "done": false,
        "TypeOfPr": "snatch",
        "ovningNr": 0
    },
    {
        "name": "Omvända Ryck",
        "percent": [57,	62,	67,	72,	75,	78,	78],
        "reps": [2, 2, 2, 2, 2,	2, 2],
        "setsDone": [false, false, false, false, false, false],
        "description": "Omvända ryck, upp till höft, sänk till golv, håll emot, ryck = 1 rep",
        "done": false,
        "TypeOfPr": "snatch",
        "ovningNr": 1
    },
    {
        "name": "Vänd+Kickstöt",
        "percent": [57,	62,	67,	72,	75,	78,	78],
        "reps": [3, 3, 3, 3, 3, 3, 3],
        "setsDone": [false, false, false, false, false, false],
        "description": "",
        "done": false,
        "TypeOfPr": "clean",
        "ovningNr": 2
    },
    {
        "name": "Stötböj",
        "percent": [77,	82,	87,	90,	93,	93],
        "reps": [2, 2, 2, 2, 2,	2],
        "setsDone": [false, false, false, false, false, false],
        "description": "Frontböj med paus under djupet av stötsatsningen",
        "done": false,
        "TypeOfPr": "clean",
        "ovningNr": 3
        
    },
    {
        "name": "Press",
        "percent": [42,	47,	50,	53,	53],
        "reps": [5, 5, 5, 5, 5],
        "setsDone": [false, false, false, false, false, false],
        "description": "Press bakom nacke stående, stötfattning",
        "done": false,
        "TypeOfPr": "clean",
        "ovningNr": 4
    }
];

export const torsdag =
[
    {
        "name": "Ryck complex",
        "percent": [33,	33,	33,	33],
        "reps": [4, 4, 4, 4],
        "setsDone": [false, false, false, false, false],
        "description": "Ryck utan bendriv+ryckpress till botten 2+2",
        "done": false,
        "TypeOfPr": "snatch",
        "ovningNr": 0
    },
    {
        "name": "Ryck från häng",
        "percent": [52,	57,	62,	67,	70,	73,	73],
        "reps": [2, 2, 2, 2, 2,	2, 2],
        "setsDone": [false, false, false, false, false, false],
        "description": "Ryck från hängande, vid mitten knät, smalben lodrät",
        "done": false,
        "TypeOfPr": "snatch",
        "ovningNr": 1
    },
    {
        "name": "Ryckdrag",
        "percent": [77,	82,	87,	90,	93,	93],
        "reps": [3, 3, 3, 3, 3,	3],
        "setsDone": [false, false, false, false, false, false],
        "description": "Ryckdrag från mitten låret",
        "done": false,
        "TypeOfPr": "snatch",
        "ovningNr": 2
    },
    {
        "name": "Stöt från rack",
        "percent": [67,	72,	75,	75,	78,	78],
        "reps": [2, 2, 2, 2, 2, 2],
        "setsDone": [false, false, false, false, false, false],
        "description": "Stöt från rack, 1 bakom nacke + 1 fram",
        "done": false,
        "TypeOfPr": "clean",
        "ovningNr": 4
    },
    {
        "name": "Press",
        "percent": [32,	37,	40,	43,	43],
        "reps": [3, 3, 3, 3, 3],
        "setsDone": [false, false, false, false, false, false],
        "description": "Press sittande, ryckfattning utan ryggstöd",
        "done": false,
        "TypeOfPr": "snatch",
        "ovningNr": 2
    }
];

export const passfyra = 
[
    {
        "name": "Rycknacke",
        "percent": [43,	43,	43,	43],
        "reps": [3, 3, 3, 3],
        "setsDone": [false, false, false, false, false],
        "description": "Rycknacke utan bendriv",
        "done": false,
        "TypeOfPr": "snatch",
        "ovningNr": 0
    },
    {
        "name": "Ryck",
        "percent": [66,	68,	71,	73,	73,	73,	73],
        "reps": [3, 3, 3, 3, 3,	3, 3],
        "setsDone": [false, false, false, false, false, false],
        "description": "Ryck från golvet",
        "done": false,
        "TypeOfPr": "snatch",
        "ovningNr": 1
    },
    {
        "name": "Överstöt",
        "percent": [72,	77,	80,	83,	83],
        "reps": [3, 3, 3, 3, 3],
        "setsDone": [false, false, false, false, false, false],
        "description": "Överstöt från rack bakom nacke",
        "done": false,
        "TypeOfPr": "clean",
        "ovningNr": 3
        
    },
    {
        "name": "Press",
        "percent": [47,	50,	53,	53],
        "reps": [4, 4, 4, 4],
        "setsDone": [false, false, false, false, false, false],
        "description": "Press från stötdipp djupet",
        "done": false,
        "TypeOfPr": "clean",
        "ovningNr": 2
    },
    {
        "name": "Sidoböj",
        "percent": [30,	30,	30, 30],
        "reps": [6, 6, 6, 6],
        "setsDone": [false, false, false, false, false, false],
        "description": "Sidoböj med kettlebell",
        "done": false,
        "TypeOfPr": "clean",
        "ovningNr": 4
    }
];